import { MessageType } from './types';
import type {
    CreateSessionCallback,
    DestroySessionCallback,
    LoadFontCallback,
    MessagePayload,
    RenderTextCallback,
    ResultCallback,
    ResultMessage,
    SessionId,
    TextBounds,
    TextProperties,
    WorkerMessage,
} from './types';

const cbMap = new Map<string, ResultCallback>();

const worker = new Worker(new URL('./worker.ts', import.meta.url), { type: 'module' });
worker.addEventListener('message', handleMessages);

function handleMessages(event: MessageEvent<ResultMessage>) {
    const { id, payload } = event.data;
    const callback = cbMap.get(id);
    if (callback) {
        callback(payload);
        cbMap.delete(id);
    }
}

function sendMessage(type: string, payload: MessagePayload, callback?: ResultCallback) {
    const id = Math.random().toString(36);
    if (callback) {
        cbMap.set(id, callback);
    }
    worker.postMessage({ id, type, payload } as WorkerMessage);
}

export function createSession(callback: CreateSessionCallback) {
    sendMessage(MessageType.CreateSession, null, callback as ResultCallback);
}

export function destroySession(sessionId: SessionId, callback?: DestroySessionCallback) {
    sendMessage(MessageType.DestroySession, { sessionId }, callback as ResultCallback);
}

export function loadFont(sessionId: SessionId, font: ArrayBuffer, callback: LoadFontCallback) {
    sendMessage(MessageType.LoadFont, { sessionId, font }, callback as ResultCallback);
}

export function renderText(
    sessionId: SessionId,
    text: string,
    properties: TextProperties,
    bounds: TextBounds,
    callback: RenderTextCallback,
) {
    sendMessage(MessageType.RenderText, { sessionId, text, properties, bounds }, callback as ResultCallback);
}

export type { ResultCallback, SessionId, TextBounds, TextProperties } from './types';
